import { Box, BoxProps } from '@jfs/ui-new'
import { useEffect } from 'react'

import ActionsMenu from '../../components/ActionMenu/ActionsMenu'
import { useStores } from '../../data/store'
import { getSelectedDate } from '../../utils/constants'

interface FraudAndRiskHeaderProps {
  type: any
  fetchDataOnChange: any
  showSearchBy?: any
  showSearchByMid?: boolean
  onSearchByMidClick?: any
  initialSearchMid?: any
  onMidChange?: any
  maxRange?: any
}

export const FraudAndRiskHeader = ({
  type,
  fetchDataOnChange,
  showSearchBy,
  showSearchByMid,
  onSearchByMidClick,
  initialSearchMid,
  onMidChange,
  maxRange,
}: FraudAndRiskHeaderProps) => {
  const { selectedEntityId, updateSelectedDateInfo } = useStores((store) => ({
    selectedEntityId: store.riskConfig.selectedEntityId,
    updateSelectedDateInfo: store.updateSelectedDateInfo,
  }))
  useEffect(() => {
    updateSelectedDateInfo({
      fromDate: getSelectedDate(2),
      toDate: new Date(Date.now()),
      position: {
        top: 0,
        left: 0,
        visible: false,
      },
      dateLabel: 'Last 7 days',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box {...styles.container}>
      <ActionsMenu
        filterVisible={false}
        setFilterVisible={null}
        showSearch={showSearchBy}
        enableFilter={false}
        showCalendar={true}
        showPagination={true}
        defaultPage={1}
        type={type}
        maxRange={maxRange}
        filterApplied={false}
        fetchDataOnChange={fetchDataOnChange}
        searchByInitialVal={selectedEntityId}
        showSearchByMid={showSearchByMid}
        onSearchByMidClick={onSearchByMidClick}
        onMidChange={onMidChange}
        initialSearchMid={initialSearchMid}
      />
    </Box>
  )
}

const styles = {
  container: {
    flexDirection: 'row',
  } as BoxProps,
}
